// mobile menu init
function initMobileNav () {
    jQuery('body').mobileNav({
        menuActiveClass: 'nav-active',
        menuOpener: '.nav-opener',
        hideOnClickOutside: true,
    });
}

jQuery(function ($) {
    const $opener = $('.nav-opener');
    const activeClass = 'nav-active';

    $opener.on('click', function (e) {
        e.preventDefault();
        $('body').toggleClass(activeClass);
    });

    // Optional: hide menu when clicking outside
    $(document).on('click touchstart', function (e) {
        if (
            $('body').hasClass(activeClass) &&
            !$(e.target).closest('.navbar__nav, .nav-opener').length
        ) {
            $('body').removeClass(activeClass);
        }
    });
});